import { Injectable } from '@angular/core';
import { SubMenuItem } from './submenu.component';

const BASE_SUBMENU_FOR_CONFIGURATION: SubMenuItem[] = [
  { label: 'Global', icon: 'fas ri-tools-fill', routerLink: '../config' },
  { label: $localize`:@@chat-bot:Chat-Bot`, icon: 'ri-chat-ai-fill', routerLink: '../chatbot' },
  { label: $localize`:@@voice-bot:Audio-Bot`, icon: 'ri-voice-ai-fill ', routerLink: '../voicebot' },
  { label: $localize`:@@avatar-tab:Avatar`, icon: 'ri-video-ai-fill', routerLink: '../avatar' },
  { label: $localize`:@@did-avatar-tab:D-ID Avatar`, icon: 'ri-video-ai-fill', routerLink: '../did-avatar' }
];

@Injectable({ providedIn: 'root' })
export class SubmenuserviceService {
  public get SUBMENU_FOR_CONFIGURATION(): SubMenuItem[] {
    return BASE_SUBMENU_FOR_CONFIGURATION;
  }
}